import { IFile } from '@app/interfaces/file';
import { ANY_OBJECT } from '@app/interfaces/interfaces';
import * as S from '../WorkerTable/WorkerTable.styles';
import { getReadableFileName } from '@app/utils/utils';
import { openFile } from '@app/utils/file';

export const fileColumns: Array<ANY_OBJECT> = [
  {
    title: 'files.table.name',
    dataIndex: 'name',
    width: 'auto',
    editable: false,
    sorter: true,
    render: (text: string, record: ANY_OBJECT): JSX.Element => {
      text = record?.originalName || record?.name;
      return (
        <S.NameColumn onClick={() => openFile(record as unknown as IFile)}>{getReadableFileName(text)}</S.NameColumn>
      );
    },
  },
  {
    title: 'files.table.fileType',
    dataIndex: 'fileType',
    width: 'auto',
    editable: false,
    sorter: false,
    render: (_text: string, record: ANY_OBJECT): JSX.Element => {
      const name = record?.originalName || record?.name;
      const fileExtension = name.split('.').pop();
      return <span>{fileExtension?.toUpperCase() || '-'}</span>;
    },
  },
  {
    title: 'files.table.description',
    dataIndex: 'description',
    width: 'auto',
    editable: false,
    sorter: true,
  },
];
